import { FormIdentifier } from '../../types/form-identifier';

export type LastOpenedFormState = Readonly<{
    // key should be a stringified NotificationIdentifier
    [key: string]: FormIdentifier | undefined;
}>;

export const initialLastOpenedFormState: LastOpenedFormState = {};
